import Select from "react-select";
import React from "react";
import {
  faultTypes,
  isSimReplacementFaultType,
  provinces,
  PAYMENT_METHODS,
  ProductType,
  CountryCode
} from '../utils.jsx';
import * as logistics from './logistics.jsx';

const STANDARD_DELIVERY_TYPE = "standard"
const RAPID_DELIVERY_TYPE = "rapid"

class FulfilmentStateFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "order_placed": {
        "icon": "shopping-1 text-info",
        "title": "Order Placed",
        "subtext": "Waiting for payment to complete",
        "selected": false
      },
      "picking_and_packing":{
        "icon": "box-2 text-info",
        "title": "Picking and Packing",
        "subtext": "Readers have been assigned, starter kit must be packed",
        "selected": false
      },
      "dispatched": {
        "icon": "delivery text-info",
        "title": "Dispatched",
        "subtext": "On the way to customer",
        "selected": false
      },
      "delivered": {
        "icon": "check-circle text-success",
        "title": "Delivered",
        "subtext": "Delivered to customer",
        "selected": false
      },
      "on_hold": {
        "icon": "clock text-muted",
        "title": "On hold",
        "subtext": "On hold",
        "selected": false
      },
      "cancelled": {
        "icon": "minus-3 text-warning",
        "title": "Cancelled",
        "subtext": "Order cancelled",
        "selected": false
      },
      "failed": {
        "icon": "alert text-danger",
        "title": "Failed",
        "subtext": "Order failed",
        "selected": false
      }
    }
  }
}

FulfilmentStateFilter.defaultProps = {
  "emptySelectedString": "All Fulfilment States",
  "filterKey": "fulfilmentState",
  "filterIcon": "icon-delivery"
};

class PaymentMethodFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "peach_payments": {
        "icon": "credit-card text-info",
        "title": "Peach Payments",
        "selected": false
      },
      "payu": {
        "icon": "credit-card text-info",
        "title": "PayU",
        "selected": false
      },
      "eft": {
        "icon": "mouse-2 text-warning",
        "title": "EFT",
        "selected": false
      },
      "free": {
        "icon": "hand-eco text-success",
        "title": "Free",
        "selected": false
      },
      "cash_on_delivery": {
        "icon": "dollar-bag",
        "title": "Cash On Delivery",
        "selected": false
      },
      "terms": {
        "icon": "mouse-2 text-success",
        "title": "Terms",
        "selected": false
      },
      "stripe": {
        "icon": "credit-card text-success",
        "title": "Stripe",
        "selected": false
      },
      "yoco_pos": {
        "icon": "miura text-info",
        "title": "Yoco POS",
        "selected": false
      }
    }
  }
}

PaymentMethodFilter.defaultProps = {
  "emptySelectedString": "All Payment Methods",
  "filterKey": "paymentMethod",
  "filterIcon": "icon-dollar-bag"
};

class PaymentStateFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "pending": {
        "icon": "clock text-info",
        "title": "Pending",
        "selected": false
      },
      "provisionally_approved": {
        "icon": "star-1 text-success",
        "title": "Provisionally Approved",
        "selected": false
      },
      "approved": {
        "icon": "check text-success",
        "title": "Approved",
        "selected": false
      },
      "failed": {
        "icon": "minus-3 text-danger",
        "title": "Failed",
        "selected": false
      },
    }
  }
}

PaymentStateFilter.defaultProps = {
  "emptySelectedString": "All Payment States",
  "filterKey": "paymentState",
  "filterIcon": "icon-streamline-sync"
};

class DeliveryMethodFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "hand_delivery": {
        "icon": "star-1",
        "title": "Hand Delivery",
        "selected": false
      },
      "collection": {
        "icon": "star-1",
        "title": "Collection",
        "selected": false
      },
      "courier": {
        "icon": "star-1",
        "title": "Courier",
        "selected": false
      },
      "not_selected": {
        "icon": "star-1",
        "title": "Not Selected",
        "selected": false
      }
    }
  }
}

DeliveryMethodFilter.defaultProps = {
  "emptySelectedString": "All Delivery Methods",
  "filterKey": "deliveryMethod",
  "filterIcon": "icon-streamline-sync" // on the filter block
};

class DispatchLocationFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "ccd_couriers": {
        "icon": "star-1",
        "title": "CCD Courier",
        "selected": false
      },
      "yoco_head_office": {
        "icon": "star-1",
        "title": "Yoco Head Office",
        "selected": false
      },
      "yoco_johannesburg": {
        "icon": "star-1",
        "title": "Yoco Johannesburg",
        "selected": false
      },
      "not_selected": {
        "icon": "star-1",
        "title": "Not Selected",
        "selected": false
      }
    }
  }
}

DispatchLocationFilter.defaultProps = {
  "emptySelectedString": "All Dispatch Locations",
  "filterKey": "dispatchLocation",
  "filterIcon": "icon-streamline-sync" // on the filter block
};

class DeliveryPartnerFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "ccd": {
        "icon": "star-1",
        "title": "CCD Couriers",
        "selected": false
      },
      "yoco": {
        "icon": "star-1",
        "title": "Yoco",
        "selected": false
      },
      "not_selected": {
        "icon": "star-1",
        "title": "Not Selected",
        "selected": false
      }
    }
  }
}

DeliveryPartnerFilter.defaultProps = {
  "emptySelectedString": "All Delivery Partners",
  "filterKey": "deliveryPartner",
  "filterIcon": "icon-streamline-sync" // on the filter block
};

class OrderPaymentsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <PaymentMethodFilter />
      <PaymentStateFilter />
    </waffle.blocks.FilterBlock>
  }
}

class OrdersFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <waffle.filters.BusinessApiFilter />
    </waffle.blocks.FilterBlock>
  }
}

class FulfilmentsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <waffle.filters.BusinessApiFilter />
      <FulfilmentStateFilter />
      <DeliveryPartnerFilter />
      <DeliveryMethodFilter />
      <DispatchLocationFilter />
    </waffle.blocks.FilterBlock>
  }
}

class OrderSimCardLink extends waffle.base.BaseComponent {

  humanize(s) {
    return s ? `(${s[0].toUpperCase() + s.slice(1)})` : '';
  }

  render() {
    const simId = this.props.id;
    const simNumber = this.props.simNumber;
    const serviceProvider = this.humanize(this.props.serviceProvider);
    const simBaseUrl = this.props.simBaseUrl;
    const link = `${simBaseUrl}${simId}`;
    return simNumber === 'empty' ? <div/> : <a href={link}>{simNumber} {serviceProvider}</a>
  }
}

class OrderType extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "first_order": {
        "text": "First Order",
        "icon": "fa fa-asterisk",
        "class": "text-success"
      },
      "reader_replacement": {
        "text": "Reader Replacement",
        "icon": "fa fa-exchange",
        "class": "text-warn"
      },
      "sim_replacement": {
        "text": "SIM Replacement",
        "icon": "fa fa-exchange",
        "class": "text-warn"
      },
      "additional_order": {
        "text": "Additional Order",
        "icon": "fa fa-plus-square",
        "class": "text-info"
      },
      "sim_additional_order": {
        "text": "SIM Additional Order",
        "icon": "fa fa-plus-square",
        "class": "text-info"
      },
    }
  }
}

class DispatchLocation extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "yoco": {
        "text": "Yoco Head Office",
        "class": "text-success"
      },
      "yoco_johannesburg": {
        "text": "Yoco Store - Johannesburg",
        "class": "text-success"
      },
      "ccd_johannesburg": {
        "text": "CCD Couriers",
      },
      "wefix": {
        "text": "WeFix",
      },
      "digicape": {
        "text": "Digicape",
      },
      "tabletpos": {
        "text": "TabletPOS",
      },
      "other": {
        "text": "Other",
      }
    }
  }
}

class PaymentMethod extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "peach_payments": {
        "text": "Peach Payments",
        "icon": "icon-credit-card",
        "class": "text-info"
      },
      "payu": {
        "text": "PayU",
        "icon": "icon-credit-card",
        "class": "text-info"
      },
      "eft": {
        "text": "EFT",
        "icon": "icon-mouse-2",
        "class": "text-warning"
      },
      "free": {
        "text": "Free",
        "icon": "icon-hand-eco",
        "class": "text-success"
      },
      "cash_on_delivery": {
        "text": "Cash On Delivery",
        "icon": "icon-dollar-bag",
        "class": ""
      },
      "terms": {
        "text": "Terms",
        "icon": "icon-calendar",
        "class": "text-info"
      },
      "stripe": {
        "icon": "icon-credit-card",
        "text": "Credit Card",
        "class": "text-success"
      },
      "retail": {
        "icon": "fa fa-shopping-bag",
        "text": "Retail",
        "class": "text-success"
      },
      "ipay": {
        "icon": "icon-mouse-2",
        "text": "iPay",
        "class": "text-success"
      },
      "yoco_pos": {
        "icon": "icon-miura",
        "text": "Yoco POS",
        "class": "text-info"
      }
    }
  }
}

class PaymentState extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "pending": {
        "text": "Pending",
        "icon": "icon-clock",
        "class": "text-info"
      },
      "approved": {
        "text": "Approved",
        "icon": "icon-check",
        "class": "text-success"
      },
      "provisionally_approved": {
        "text": "Provisionally approved",
        "icon": "icon-check",
        "class": "text-info"
      },
      "failed": {
        "text": "Failed",
        "icon": "icon-minus-3",
        "class": "text-danger"
      },
    }
  }
}

class FulfilmentState extends waffle.misc.Enumerator {

  valueMap() {

    const retailOrderLabel = this.props.parent.deliveryDetails.deliveryMethod === "retail" ? "[Retail Order]" : "";

    return {
      "awaiting_payment": {
        "text": `Awaiting Payment ${retailOrderLabel}`,
        "icon": "fa fa-credit-card",
        "class": "text-warning"
      },
      "order_placed": {
        "text": `Order Placed ${retailOrderLabel}`,
        "icon": "fa fa-clock-o",
        "class": "text-warning"
      },
      "assigning_readers": {
        "text": `Assigning Readers ${retailOrderLabel}`,
        "icon": "icon-miura",
        "class": "text-info"
      },
      "picking_and_packing": {
        "text": `Picking and Packing ${retailOrderLabel}`,
        "icon": "icon-box",
        "class": "text-info"
      },
      "dispatched": {
        "text": `Dispatched ${retailOrderLabel}`,
        "icon": "fa fa-truck",
        "class": "text-info"
      },
      "ready_for_collection": {
        "text": `Ready for Collection ${retailOrderLabel}`,
        "icon": "fa fa-upload",
        "class": "text-info"
      },
      "dispatched_no_email": {
        "text": `Dispatched ${retailOrderLabel}`,
        "icon": "fa fa-truck",
        "class": "text-info"
      },
      "delivered": {
        "text": `Delivered ${retailOrderLabel}`,
        "icon": "fa fa-check-square",
        "class": "text-success"
      },
      "on_hold": {
        "text": `On Hold ${retailOrderLabel}`,
        "icon": "fa fa-clock-o",
        "class": "text-muted"
      },
      "cancelled": {
        "text": `Cancelled ${retailOrderLabel}`,
        "icon": "fa fa-exclamation-triangle",
        "class": "text-warning"
      },
      "failed": {
        "text": `Failed ${retailOrderLabel}`,
        "icon": "fa fa-times-circle",
        "class": "text-error"
      },
      "returned": {
        "text": `Returned ${retailOrderLabel}`,
        "icon": "fa fa-times-circle",
        "class": "text-error"
      },
      "returned_bough_back": {
        "text": `Returned Bought Back ${retailOrderLabel}`,
        "icon": "fa fa-rotate-left",
        "class": "text-error"
      },
      "returned_refund": {
        "text": `Returned Refund ${retailOrderLabel}`,
        "icon": "fa fa-rotate-left",
        "class": "text-error"
      },
      "transfer_of_ownership": {
        "text": `Transfer of Ownership ${retailOrderLabel}`,
        "icon": "fa fa-arrow-right",
        "class": "text-info"
      },
      "card_machine_transferred": {
        "text": `Card Machine Transferred ${retailOrderLabel}`,
        "icon": "fa fa-arrow-right",
        "class": "text-info"
      },
    }
  }
}

class OrderIssuesBanner extends waffle.base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      hasCardMachineReturned: undefined,
    });
  }

  componentWillMount() {
    this.fetchOrder();
  }

  render() {
    const hasCardMachineReturned = this.state.hasCardMachineReturned ?
        <div className={'order-has-returns-block alert alert-info'}>
          A card machine has been returned on this fulfilment.</div> : <div/>;

    return (
        <div className={'order-issues-block'}>
          {hasCardMachineReturned}
        </div>
    );
  }

  fetchOrder() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/logistics/fulfilments/${this.props.fulfilmentId}`,
      dataType: 'json',
      type: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.setState({
          hasCardMachineReturned: response.data.metadata.has_card_machine_returned
        });
      } else {
        radio('showAlert').broadcast('danger', response.message);
      }
    }).fail((unused, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }
}

// Card machines that need to be replaced
class CardMachineSelectFields extends waffle.base.BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      rows: [{serialNumber: undefined, faultyReason: undefined, readerSuggestions: []}],
      faultyReasons: faultTypes(),
      businessReaders:[]
    }
  }

  addRow() {
    this.setState({
      rows: [...this.state.rows, {serialNumber: undefined, faultyReason: undefined, readerProduct: undefined, readerSuggestions: []}]
    })
  }

  searchForReader(index) {
    const searchInput = document.getElementById("reader-search-input-" + index);
    $.ajax({
      url: `/api/readers/allocatedToBusiness/${this.props.businessUUID}?serialNumber=${searchInput.value}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        const readers = response.data.readers;
        if (readers.length === 1 && readers[0].serialNumber === searchInput.value) {
          this.updateRowReader(readers[0], index);
          this.updateRowReaderSuggestions([], index)
        } else {
          this.updateRowReaderSuggestions(response.data.readers, index)
        }
      }
    })
  }

  updateRowReaderSuggestions(readers, index) {
    const newRow = this.state.rows[index];
    newRow.readerSuggestions = readers;
    const newRows = this.state.rows;
    newRows[index] = newRow;
    this.updateRows(newRows)
  }

  updateRowReader(reader, index) {
    const newRow = this.state.rows[index];
    newRow.serialNumber = reader.serialNumber;
    newRow.uuid = reader.uuid;
    newRow.readerProduct = reader.readerProduct;
    const newRows = this.state.rows;
    newRows[index] = newRow;
    this.updateRows(newRows)
  }

  updateRowFaultyReason(event, index) {
    const newFaultyReason = this.state.faultyReasons.filter((item) => item.value === event.value)[0];
    const newRow = this.state.rows[index];
    newRow.faultyReason = newFaultyReason.value;
    const newRows = this.state.rows;
    newRows[index] = newRow;
    this.updateRows(newRows)
  }

  updateRows(newRows) {
    this.setState({
      rows: newRows
    });
    this.props.onUpdateRows(newRows)
  }

  removeRow(index) {
    const newRows = this.state.rows;
    newRows.splice(index, 1);
    this.updateRows(newRows)
  }

  handleKeyPress(event, index) {
    if (event.key === 'Enter') {
      event.preventDefault();
    } else {
      this.searchForReader(index)
    }
  }

  handleClickOnReaderSuggestion(reader, index) {
    this.updateRowReader(reader, index);
    this.updateRowReaderSuggestions([], index);
  }

  readerRow(row, index) {

    const key = "reader-search-input-" + index;
    return (
        <div key={key}>
          <div className="reader-select-row">
            <input
                id={key}
                value={row.serialNumber || ''}
                onChange={(event) => this.updateRowReader({serialNumber: event.target.value}, index)}
                placeholder="Type a serial number..."
                type="search"
                onKeyUp={(event) => this.handleKeyPress(event, index)}/>
            {this.props.enableReason ? <Select
                className='reason-select reason-input'
                placeholder={'Select reason...'}
                inputValue={this.state.inputValue}
                onInputChange={inputValue => this.setState({ inputValue: inputValue })}
                options={this.state.faultyReasons}
                onChange={(event) => this.updateRowFaultyReason(event, index)}
                searchable={false}
                clearable={false}
                cacheAsyncResults={false}
            /> : <div/>}
            <button className="btn-danger" onClick={() => this.removeRow(index)}>Remove</button>
          </div>
          <div>
            <ul id="business-list">
              {
                row.readerSuggestions.map((reader, key) =>
                    <li key={reader.uuid} id={reader.uuid}
                        onClick={(event) => this.handleClickOnReaderSuggestion(reader, index)}>
                      {reader.serialNumber}
                    </li>
                )
              }
            </ul>
          </div>
        </div>
    )
  }

  render() {
    return (
        <div className="row">
          <label className="col-lg-3 faulty-items">Faulty Items</label>
          <div className="col-lg-5">
            <button className="btn-info add-reader-row-button" onClick={this.addRow.bind(this)}>+ Add</button>
            <div className="reader-select-container">
              <label >Serial Number</label>
              <label className="reason-select-label">Reason for return</label>
              <div>
                {this.state.rows.map((row, index) => this.readerRow(row, index))}
              </div>
            </div>
          </div>
        </div>
    )
  }
}

// Items for the order: new items to be sent (card machines or SIM cards)
class OrderItemsFields extends waffle.base.BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      items: [],
    }
  }

  loadAvailableItems() {
    $.ajax({
      url: this.props.itemTypes ? `/api/products/?type__in=${this.props.itemTypes.join(",")}` : '/api/products/',
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setState({
          items: this.initItems(response.data)
        })
      }
    })
  }

  componentWillMount() {
    this.loadAvailableItems();
  }

  initItems(items) {
    return items.sort((r1, r2) => {
      if (r1.name.toLowerCase() < r2.name.toLowerCase()) {
        return -1
      } else if (r1.name.toLowerCase() > r2.name.toLowerCase()) {
        return 1
      } else {
        return 0
      }
    }).map(item => ({...item, quantity: 0}))
  }

  updateItem(item, quantity, price) {
    this.setState({
      items: this.state.items.map(i => {
        if (i.id === item.id) {
          return {
            ...i,
            quantity: quantity ? quantity : i.quantity,
            unit_price: price ? price : i.unit_price
          }
        }

        return i;
      })
    }, () => this.props.onItemChange(this.state.items.filter(i => i.id === item.id )[0]))
  }

  render() {
    return (
        <div className="row order-items">
          <label className="col-lg-3">Order Items</label>
          <div className="col-lg-5">
            <table className="table list-unstyled">
              <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Quantity</th>
                  <th><span className="required-field"></span></th>
              </tr>
              </thead>
              <tbody>
              {this.state.items.map(item =>
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>
                      <input
                          type="number"
                          step="0.01"
                          min="0"
                          className="form-control small"
                          disabled={this.props.paymentMethod.label === "Free"}
                          value={this.props.paymentMethod.label === "Free" ? "0.00" : item.unit_price}
                          onChange={event => this.updateItem(item, null, event.target.value)}
                      />
                    </td>
                    <td>
                      <input
                          type="number"
                          className="form-control reader-order-item-quantity"
                          min="0"
                          value={item.quantity}
                          onChange={event => this.updateItem(item, event.target.value, null)}
                      />
                    </td>
                  </tr>
              )}
              </tbody>
            </table>
          </div>
        </div>
    )
  }
}

const shallowCompare = (obj1, obj2) =>
    Object.keys(obj1).length === Object.keys(obj2).length &&
    Object.keys(obj1).every(key =>
        obj2.hasOwnProperty(key) && obj1[key] === obj2[key]
    );

//Details for the customer for create  and replace order
class CustomerDetails extends waffle.base.BaseComponent {
  constructor(props) {
    super(props)

    let customerDetailsData = this.props.data
    if (!customerDetailsData || Object.keys(customerDetailsData).length === 0) {
      customerDetailsData = {
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
      }
    }

    this.state = {
      data: customerDetailsData,
    }
  }

  componentDidMount() {
    this.updateCustomerDetails()
  }

  componentDidUpdate(prevProps) {
      if (prevProps.data && !shallowCompare(prevProps.data, this.props.data)) {
        this.updateCustomerDetails(this.props.data)
      }
  }

  updateCustomerDetails(updatedData) {
    const updateOnCustomerDetailsChangeListener = () => this.props.onCustomerDetailsChange({
      customerDetails: this.state.data,
      validationErrors: this.validate()
    })

    if (updatedData) {
      this.setState({data: updatedData}, () => {
        updateOnCustomerDetailsChangeListener()
      })
    } else {
      updateOnCustomerDetailsChangeListener()
    }
  }

  // Returns validation errors if there are any
  validate() {
    const errors = []
    if (!this.state.data.firstName) {
      errors.push({
        field: "firstName",
        error: "Customer Name is required"
      })
    }

    if (!this.state.data.lastName) {
      errors.push({
        field: "lastName",
        error: "Customer Surname is required"
      })
    }

    if (!this.state.data.email) {
      errors.push({
        field: "email",
        error: "Email is required"
      })
    }

    if (!this.state.data.mobileNumber) {
      errors.push({
        field: "mobileNumber",
        error: "Mobile Number is required"
      })
    }

    return errors
  }

  render() {
    return (
        <div>
          <div className="flex-box row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label">Customer Details</label>
            <div className="flex-field">
              <label className="control-label left-input">Customer Name</label>
              <span className="required-field"></span>
              <br/>
              <input required name="firstName" value={this.state.data.firstName}
                    type="text"
                    className="form-control medium-input left-input half-width"
                    onChange={(e) => this.updateCustomerDetails(Object.assign({}, this.state.data, {firstName: e.target.value}))}
                    onBlur={(e) => {
                      this.updateCustomerDetails(Object.assign({}, this.state.data, {firstName: e.target.value}))
                    }}
              />

            </div>
            <div className="flex-field">
              <label className="control-label input-margin">Customer Surname</label>
              <span className="required-field"></span>
              <input name="lastName" value={this.state.data.lastName} type="text"
                    className="form-control medium-input input-margin half-width"
                    onChange={(e) => this.updateCustomerDetails(Object.assign({}, this.state.data, {lastName: e.target.value}))}
                    onBlur={(e) => {
                      this.updateCustomerDetails(Object.assign({}, this.state.data, {lastName: e.target.value}))
                    }}
              />
            </div>
          </div>

          <div className="flex-box row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="flex-field ">
              <label className="control-label left-input">Email</label>
              <span className="required-field"></span>
              <br/>
              <input id="email" value={this.state.data.email} type="text"
                    className="form-control medium-input left-input half-width"
                    onChange={(e) => this.updateCustomerDetails(Object.assign({}, this.state.data, {email: e.target.value}))}
                    onBlur={(e) => {
                      this.updateCustomerDetails(Object.assign({}, this.state.data, {email: e.target.value}))
                    }}
              />
            </div>
            <div className="flex-field ">
              <label className="control-label input-margin">Mobile Number</label>
              <span className="required-field"></span>
              <input id="mobileNumber" name="mobileNumber" value={this.state.data.mobileNumber} type="text"
                    className="form-control medium-input input-margin half-width"
                    onChange={(e) => this.updateCustomerDetails(Object.assign({}, this.state.data, {mobileNumber: e.target.value}))}
                    onBlur={(e) => {
                      this.updateCustomerDetails(Object.assign({}, this.state.data, {mobileNumber: e.target.value}))
                    }}
              />
            </div>
          </div>
        </div>
    )
  }
}

// Common fields across countries:  `firstLine, secondLine, countryCode`;
// `city` is common, but data sources may vary, hence it gets implemented per country.
class CommonAddressDetails extends waffle.base.BaseComponent {
  constructor(props) {
    super(props)

    let commonDetailsData = this.props.data
    if (!commonDetailsData || Object.keys(commonDetailsData).length === 0) {
      commonDetailsData = {
        firstLine: '',
        secondLine: '',
        countryCode: this.props?.countryCode,
      }
    }

    const countryName = Object.keys(CountryCode)[Object.values(CountryCode).indexOf(this.props?.countryCode)];

    this.state = {
      country: {value: this.props?.countryCode, label: countryName},
      data: commonDetailsData,
      showConfirmation: true
    }
  }

  componentDidMount() {
    this.updateCommonAddressDetails()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data && this.props.data && !shallowCompare(prevProps.data, this.props.data)) {
      this.updateCommonAddressDetails(this.props.data)
    }
  }

  updateCommonAddressDetails(updatedData) {
    const updateOnCommonAddressDetailsChangeListener = () => this.props.onCommonAddressDetailsChange({
      commonDetails: this.state.data,
      validationErrors: this.validate()
    })

    if (updatedData) {
      this.setState({data: updatedData}, () => {
        updateOnCommonAddressDetailsChangeListener()
      })
    } else {
      updateOnCommonAddressDetailsChangeListener()
    }
  }

  // Returns validation errors if there are any
  validate() {
    const errors = []

    if (!this.state.data.firstLine) {
      errors.push({
        field: "firstLine",
        error: "First line address is required"
      })
    }
    return errors
  }

  render() {
    return (
        <div>
          <div className="row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="col-lg-5">
              <label className="control-label">Country</label>
              <span className="required-field"></span>
              <br/>
              <div className="full-width">
                <Select
                    value={this.state.country}
                    isDisabled={true}
                    iSearchable={false}
                    isClearable={false}
                    cacheAsyncResults={false}
                />
              </div>
            </div>
          </div>

          <div className="row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="col-lg-5 ">
              <label className="control-label">Line Address</label>
              <br/>
              <input id="addressLine" value={this.state.data.firstLine}
                    type="text"
                    className="form-control input-border-radius "
                    onChange={(e) => this.updateCommonAddressDetails(Object.assign({}, this.state.data, {firstLine: e.target.value}))}
                    onBlur={(e) => {
                      this.updateCommonAddressDetails(Object.assign({}, this.state.data, {firstLine: e.target.value}))
                    }}
              />
            </div>
            <div className="required-field-margins">
              <span className="required-field"></span>
            </div>
          </div>

          <div className="row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="col-lg-5">
              <input id="addressLine2" value={this.state.data.secondLine}
                    type="text"
                    className="form-control input-border-radius"
                    onChange={(e) => this.updateCommonAddressDetails(Object.assign({}, this.state.data, {secondLine: e.target.value}))}
                    onBlur={(e) => {
                      this.updateCommonAddressDetails(Object.assign({}, this.state.data, {secondLine: e.target.value}))
                    }}
              />
            </div>
          </div>
        </div>
    )
  }
}

// Renders fields specific to ZA flow `suburb, city, postal_code, and province`
class ZAAddressDetails extends waffle.base.BaseComponent {
  constructor(props) {
    super(props)

    let address = this.props.data
    if (!address || Object.keys(address).length === 0) {
      address = {
        suburb: '',
        province: '',
        postalCode: '',
        city: ''
      }
    }

    this.state = {
      provinces: provinces().map(province => {
        return {value: province, label: province}
      }),
      data: address,
    }
  }

  componentDidMount() {
    this.updateZAAddress()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data && !shallowCompare(prevProps.data, this.props.data)) {
        this.updateZAAddress(this.props.data)
    }
  }

  updateZAAddress(updatedData) {
    const updateOnZAAddressDetailsChangeListener = () => this.props.onZAAddressDetailsChange({
      zaAddressDetails: this.state.data,
      validationErrors: this.validate()
    })
    if (updatedData) {
      this.setState({data: updatedData}, () => {
        updateOnZAAddressDetailsChangeListener()
      })
    } else {
      updateOnZAAddressDetailsChangeListener()
    }
  }

  // Returns validation errors if there are any
  validate() {
    const errors = []

    if (!this.state.data.city) {
      errors.push({
        field: "city",
        error: "City is required"
      })
    }

    if (!this.state.data.postalCode) {
      errors.push({
        field: "postalCode",
        error: "Postal code is required"
      })
    }

    if (!this.state.data.province) {
      errors.push({
        field: "province",
        error: "Province is required"
      })
    }
    return errors
  }

  render() {
    return (
        <div>

          <div className="flex-box row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="flex-field">
              <label className="control-label left-input">Suburb</label>
              <span className="required-field"></span>
              <br/>
              <input id="suburb" value={this.state.data?.suburb}
                    type="text"
                    className="form-control medium-input left-input half-width"
                    onChange={(e) => this.updateZAAddress(Object.assign({}, this.state.data, {suburb: e.target.value}))}
                    onBlur={(e) => {
                      this.updateZAAddress(Object.assign({}, this.state.data, {suburb: e.target.value}))
                    }}
              />
            </div>
          </div>

          <div className="flex-box row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="flex-field">
              <label className="control-label left-input">City</label>
              <span className="required-field"></span>
              <br/>
              <input id="city"
                    value={this.state.data.city}
                    type="text"
                    className="form-control medium-input left-input half-width"
                    onChange={(e) => this.updateZAAddress(Object.assign({}, this.state.data, {city: e.target.value}))}
                    onBlur={(e) => {
                      this.updateZAAddress(Object.assign({}, this.state.data, {city: e.target.value}))
                    }}
              />
            </div>
          </div>

          <div className="flex-box row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label"></label>
            <div className="flex-field">
              <label className="control-label left-input">Province</label>
              <span className="required-field"></span>
              <br/>
              <div className="">
                <Select
                    className="col-lg-5 select-medium-width half-width"
                    name="province"
                    placeholder={'Select province...'}
                    options={this.state.provinces}
                    value={this.state.provinces.filter(province => province.value === this.state.data?.province)}
                    onChange={updatedProvince => {
                      this.setState({data: Object.assign({}, this.state.data, {province: updatedProvince.value})}, () => {
                        this.updateZAAddress()
                      })
                    }}
                    searchable={false}
                    clearable={false}
                    cacheAsyncResults={false}
                />
              </div>

            </div>
            <div className="flex-field">
              <label className="control-label input-margin">Postal Code</label>
              <span className="required-field"></span>
              <input id="postalCode" name="postalCode"
                    defaultValue={this.state.data.postalCode}
                    type="text"
                    className="form-control medium-input input-margin input-height half-width"
                    onChange={(e) => this.updateZAAddress(Object.assign({}, this.state.data, {postalCode: e.target.value}))}
                    onBlur={(e) => {
                      this.updateZAAddress(Object.assign({}, this.state.data, {postalCode: e.target.value}))
                    }}
              />
            </div>
          </div>
        </div>
    )
  }
}

// Delivery method & dispatch location to create and replace order
class DeliveryDetails extends waffle.base.BaseComponent {
  constructor(props) {
    super(props)

    this.state = {
      deliveryMethod: null,
      dispatchLocation: null,
      deliveryType: null,
      isReplacementOrder: !!props.isReplacementOrder
    }
  }

  getDeliveryMethods() {
    $.ajax({
      url: `/api/logistics/delivery-methods`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setState({
          deliveryMethods: response.data.map(deliveryMethod => {
            return {value: deliveryMethod, label: deliveryMethod}
          }),
        })
      } else {
        radio('showAlert').broadcast('danger', `Failed to fetch delivery methods (${response.status}): ${response.message}`);
      }
    })
  }

  getDispatchLocations(deliveryMethod) {
    $.ajax({
      url: `/api/logistics/dispatch-locations?delivery_method=${deliveryMethod.value}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setState({
          dispatchLocations: response.data.map(dispatchLocation => {
            return {value: dispatchLocation, label: dispatchLocation}
          }),
        })
      } else {
        radio('showAlert').broadcast('danger', `Failed to fetch dispatch locations (${response.status}): ${response.message}`);
      }
    })
  }

  getDeliveryTypes(deliveryMethod) {
    let url = `/api/logistics/delivery-types?delivery_method=${deliveryMethod.value}`

    if (this.state.isReplacementOrder) {
      url = `${url}&action=replacement_order`
    }

    $.ajax({
      url: url,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        const deliveryTypes = response.data.map(deliveryType => {
          // For 'rapid' delivery type, we want to just indicate that it is limited to key accounts
          let deliveryTypeLabel = deliveryType
          if (deliveryType === RAPID_DELIVERY_TYPE) {
            deliveryTypeLabel = `${deliveryType} (limited to key accounts)`
          }
          return {value: deliveryType, label: deliveryTypeLabel}
        })

        let deliveryType = this.state.deliveryType
        // If there is a delivery type already set, try to find the matching entry in the list of new delivery types,
        // otherwise default to 'standard'
        if (deliveryType) {
          const matching_delivery_types = deliveryTypes.filter(dt => dt.value === deliveryType.value)
          if (matching_delivery_types.length > 0) {
            deliveryType = matching_delivery_types[0]
          } else {
            deliveryType = null
          }
        }

        if (!deliveryType) {
          deliveryType = deliveryTypes.filter(dt => dt.value === STANDARD_DELIVERY_TYPE)[0]
        }

        this.setState({
          deliveryTypes: deliveryTypes,
          deliveryType: deliveryType
        })
      } else {
        radio('showAlert').broadcast('danger', `Failed to fetch delivery types (${response.status}): ${response.message}`);
      }
    })
  }

  componentDidMount() {
    this.getDeliveryMethods()
    this.updateDeliveryDetails()
  }

  updateDeliveryDetails(updatedDeliveryDetails) {
    const updateOnDeliveryDetailsChangeListener = () => this.props.onDeliveryDetailsChange({
      deliveryDetails: {
        deliveryMethod: this.state.deliveryMethod ? this.state.deliveryMethod.value : null,
        dispatchLocation: this.state.dispatchLocation ? this.state.dispatchLocation.value : null,
        deliveryType: this.state.deliveryType ? this.state.deliveryType.value : null,
      },
      validationErrors: this.validate()
    })

    if (updatedDeliveryDetails) {
      let updatedState = updatedDeliveryDetails
      if (updatedDeliveryDetails.deliveryMethod) {
        this.getDispatchLocations(updatedDeliveryDetails.deliveryMethod)

        if (this.state.isReplacementOrder) {
          this.getDeliveryTypes(updatedDeliveryDetails.deliveryMethod)
        }
      }
      this.setState(updatedState, () => {
        updateOnDeliveryDetailsChangeListener()
      })
    } else {
      updateOnDeliveryDetailsChangeListener()
    }
  }

  validate() {
    const errors = []

    if (!this.state.deliveryMethod) {
      errors.push({
        field: "deliveryMethod",
        error: "Delivery method is required"
      })
    }

    if (!this.state.dispatchLocation) {
      errors.push({
        field: "dispatchLocation",
        error: "Dispatch location is required"
      })
    }

    if (this.state.isReplacementOrder && !this.state.deliveryType) {
      errors.push({
        field: "deliveryType",
        error: "Delivery Type is required"
      })
    }

    return errors
  }

  render() {
    return <div>
      <div className="row" style={{paddingBottom: '10px', paddingTop: '40px'}}>
        <label className="col-lg-3 control-label">Delivery Method</label>
        <div className="col-lg-5">
          <Select
              name='deliveryMethod'
              placeholder={'Select option...'}
              options={this.state.deliveryMethods}
              value={this.state.deliveryMethod}
              onChange={e => {
                this.updateDeliveryDetails({deliveryMethod: e, dispatchLocation: null})
              }}
              searchable={false}
              clearable={false}
              cacheAsyncResults={false}
          />

        </div>
        <div className="col-lg-3 required-field-extended-margins">
          <span className="required-field required-field-margins"></span>
        </div>
      </div>

      <div className="row" style={{paddingBottom: '10px'}}>
        <label className="col-lg-3 control-label">Dispatch Location</label>
        <div className="col-lg-5">
          <Select
              name='dispatchLocation'
              placeholder={'Select option...'}
              options={this.state.dispatchLocations}
              value={this.state.dispatchLocation}
              onChange={e => {
                this.updateDeliveryDetails({dispatchLocation: e})
              }}
              searchable={false}
              clearable={true}
              cacheAsyncResults={false}
          />
        </div>
        <div className="col-lg-3 required-field-extended-margins">
          <span className="required-field required-field-margins"></span>
        </div>
      </div>

      {this.state.isReplacementOrder &&
          <div className="row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label">Delivery Type</label>
            <div className="col-lg-5">
              <Select
                  name='deliveryType'
                  placeholder={'Select option...'}
                  options={this.state.deliveryTypes}
                  value={this.state.deliveryType}
                  onChange={e => {
                    this.updateDeliveryDetails({deliveryType: e})
                  }}
                  searchable={false}
                  clearable={true}
                  cacheAsyncResults={false}
              />
            </div>
            <div className="col-lg-3 required-field-extended-margins">
              <span className="required-field required-field-margins"></span>
            </div>
          </div>
      }
    </div>
  }
}

class CreateOrderForm extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethods: PAYMENT_METHODS.map(payment => {
        return {value: payment, label: payment}
      }),
      paymentMethod: {value: props.isReplacementOrder ? "Free" : "EFT"  , label: props.isReplacementOrder ? "Free" : "EFT"},
      items: [],
      readers: [],
      creatingOrder: false,
      customerDetails: {},
      commonDetails: {},
      zaAddressDetails: {},
      egAddressDetails: {},
      deliveryDetails: {},
      business: {
        name: null,
        uuid: this.props.businessUUID
      },
      addressConfirmed: false,
      showAddressConfirmation: false
    };
  }

  componentDidMount() {
    this.setBusinessInfo();

    if (this.props.isReplacementOrder) {
      $.ajax({
        url: `/api/businesses/${this.state.business.uuid}/readers?pageSize=0`,
        method: 'GET',
      }).done((response) => {
        if (response.status === 200) {
          this.setState({businessReaders: response.data.readers})
        }
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.business.uuid !== this.state.business.uuid) {
      this.setBusinessInfo()
    }
  }

  async setBusinessInfo() {
    if (!this.state.business.uuid) {
      return
    }

    let orderApi = new OrderApi();
    const response = await orderApi.fetchBusinessInfo(this.state.business.uuid)

    if (response) {
      this.setState({
        business: {name: response.data.business.name, uuid: response.data.business.uuid},
        customerDetails: {
          firstName: response.data.business.owner.firstName,
          lastName: response.data.business.owner.lastName,
          email: response.data.business.owner.email,
          mobileNumber: response.data.business.info.telephoneNumber,
        },
        commonDetails: {
          firstLine: response.data.business.addresses[0]?.firstLine,
          secondLine: response.data.business.addresses[0]?.secondLine,
          city: response.data.business.addresses[0]?.city,
          countryCode: response.data.business.addresses[0]?.countryCode,
        },
        zaAddressDetails: {
          city: response.data.business.addresses[0]?.city,
          suburb: response.data.business.addresses[0]?.suburb ? response.data.business.addresses[0]?.suburb : '',
          province: response.data.business.addresses[0]?.province,
          postalCode: response.data.business.addresses[0]?.postalCode
        }
      })
    }
  }

  onCustomerDetailsChange({customerDetails, validationErrors}) {
    this.setState({
      customerDetails: customerDetails,
      customerDetailsErrors: validationErrors
    })
  }

  onCommonAddressDetailsChange({commonDetails, validationErrors}) {
    this.setState({
      commonDetails: commonDetails,
      commonDetailsErrors: validationErrors
    })
  }

  onZAAddressDetailsChange({zaAddressDetails, validationErrors}) {
    this.setState({
      zaAddressDetails: zaAddressDetails,
      zaAddressDetailsErrors: validationErrors
    })
  }

  onDeliveryDetailsChange({deliveryDetails, validationErrors}) {
    this.setState({
      deliveryDetails: deliveryDetails,
      deliveryDetailsErrors: validationErrors
    })
  }

  onItemChange(item) {
    const items = this.state.items;
    const existingItemIndex = items.findIndex(i => i.id === item.id);
    if (existingItemIndex !== -1) {
      items[existingItemIndex] = Object.assign({}, item)
    } else {
      items.push(Object.assign({}, item))
    }
    this.setState({
      items: items
    })
  }

  businessSelected(business) {
    this.setState({
      business: {
        name: business.name,
        uuid: business.uuid
      },
    });
  }

  performCommonValidation(orderItems) {
    if (this.state.customerDetailsErrors && this.state.customerDetailsErrors.length > 0) {
      this.state.customerDetailsErrors.reverse().forEach(error => {
        radio('showAlert').broadcast('danger', error.error);
      })
      return false;
    }

    if (this.state.commonDetailsErrors && this.state.commonDetailsErrors.length > 0) {
      this.state.commonDetailsErrors.reverse().forEach(error => {
        radio('showAlert').broadcast('danger', error.error);
      })
      return false;
    }

    if (this.state.zaAddressDetailsErrors && this.state.zaAddressDetailsErrors.length > 0 && this.props?.targetCountry === CountryCode.ZA) {
      this.state.zaAddressDetailsErrors.reverse().forEach(error => {
        radio('showAlert').broadcast('danger', error.error);
      })
      return false;
    }

    if (this.state.deliveryDetailsErrors.length > 0) {
      this.state.deliveryDetailsErrors.reverse().forEach(error => {
        radio('showAlert').broadcast('danger', error.error);
      })
      return false;
    }

    if (orderItems.length === 0) {
      radio('showAlert').broadcast('danger', 'Order must have at least one item');
      return false;
    }

    if (!this.state.paymentMethod) {
      radio('showAlert').broadcast('danger', 'Payment method is required');
      return false;
    }

    return true;
  }

  performValidationForReplacementOrder(replacedItems) {
    if (replacedItems.length === 0) {
      radio('showAlert').broadcast('danger', 'Order must have at least one card machine to be returned');
      return false;
    }

    if (replacedItems.filter(r => r.fault_type === undefined || r.serial_number === undefined).length > 0) {
      radio('showAlert').broadcast('danger', 'Card machines to be returned need both a serial number and a fault reason to be filled');
      return false;
    }

    if (new Set(replacedItems.map(r => r.serial_number)).size < replacedItems.length) {
      radio('showAlert').broadcast('danger', 'Can\'t replace the same card machine multiple times');
      return false;
    }

    if (replacedItems.filter(r => isSimReplacementFaultType(r.fault_type)).length > 0 &&
        this.state.readers.filter(r => r.readerProduct && !r.readerProduct.containsSim).length > 0) {
      radio('showAlert').broadcast('danger', 'Can\'t select a card machine that doesn\'t contain a SIM');
      return false;
    }

    if (replacedItems.filter(r => this.state.businessReaders.some(b => b.serialNumber === r.serial_number)).length !== replacedItems.length) {
      radio('showAlert').broadcast('danger', 'Card machines to be returned needs to be allocated to the business');
      return false;
    }

    return true;
  }

  createOrder() {
    const orderItems = this.state.items.filter(i => i.quantity > 0).map(i => ({
      quantity: parseInt(i.quantity),
      product: i.id,
      unit_price: this.state.paymentMethod.label === "Free" ? 0 : i.unit_price,
    }));
    let replacedItems = this.props.isReplacementOrder ?
        this.state.readers.map(reader => ({
          id: reader.uuid,
          serial_number: reader.serialNumber,
          fault_type: reader.faultyReason,
        })) : [];
    
    if (!this.performCommonValidation(orderItems)) {
      return;
    }

    if (this.props.isReplacementOrder && !this.performValidationForReplacementOrder(replacedItems)) {
      return;
    }

    if (!this.props.confirmAddress || this.state.addressConfirmed) {
      this.setState({
        creatingOrder: true
      }, () => {
        let orderApi = new OrderApi();
        orderApi.createOrder({
          businessUUID: this.state.business.uuid,
          customerDetails: this.state.customerDetails,
          commonDetails: this.state.commonDetails,
          zaAddressDetails: this.state.zaAddressDetails,
          deliveryDetails: this.state.deliveryDetails,
          paymentMethod: this.state.paymentMethod.value,
          items: orderItems,
          country: this.props?.targetCountry,
          replacedItems
        });

        this.setState({creatingOrder: false});
      });
    } else {
      this.setState({
        showAddressConfirmation: true
      });
    }
  }

  onCardMachinesChange(readers) {
    this.setState({
      readers: readers
    });
  }

  renderAddress() {
    switch (this.props?.targetCountry) {
      default:
        return <ZAAddressDetails
            data={this.state.zaAddressDetails}
            onZAAddressDetailsChange={this.onZAAddressDetailsChange.bind(this)}
        ></ZAAddressDetails>;
    }
  };

  render() {
    return (
        <div>
          <header>
            <h1>Add order</h1>
          </header>
          <div className="row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label title-set">Business</label>
            <div className="col-lg-5">
              {!this.props.businessUUID ? (
                  <logistics.BusinessSelectField
                      onFullOptionChanged={this.businessSelected.bind(this)}/>
              ) : (
                  <Select
                      name="business"
                      placeholder={'Pick a business'}
                      value={{label: this.state.business.name, value: this.state.business.uuid}}
                      isDisabled={true}
                      iSearchable={false}
                      isClearable={false}
                      cacheAsyncResults={false}
                  />
              )}
            </div>
          </div>

          <CustomerDetails
              data={this.state.customerDetails}
              onCustomerDetailsChange={this.onCustomerDetailsChange.bind(this)}
          ></CustomerDetails>

          <CommonAddressDetails
              countryCode={this.props.targetCountry}
              data={this.state.commonDetails}
              onCommonAddressDetailsChange={this.onCommonAddressDetailsChange.bind(this)}
          ></CommonAddressDetails>

          {this.renderAddress()}

          <DeliveryDetails
              isReplacementOrder={this.props.isReplacementOrder}
              onDeliveryDetailsChange={this.onDeliveryDetailsChange.bind(this)}
          ></DeliveryDetails>

          <div className="row" style={{paddingBottom: '10px'}}>
            <label className="col-lg-3 control-label">Payment Method</label>
            <div className="col-lg-5">
              <Select
                  name='paymentMethod'
                  placeholder={'Select option...'}
                  options={this.state.paymentMethods}
                  value={this.state.paymentMethod}
                  onChange={e => this.setState({paymentMethod: e})}
                  searchable={false}
                  clearable={false}
                  cacheAsyncResults={false}
              />
            </div>
            <div className="col-lg-3 required-field-extended-margins">
              <span className="required-field required-field-margins"></span>
            </div>
          </div>

          <div>
            {this.props.isReplacementOrder && <CardMachineSelectFields
                businessUUID={this.state.business.uuid}
                onUpdateRows={this.onCardMachinesChange.bind(this)}
                enableReason={true}
            />}
            <OrderItemsFields
                onItemChange={this.onItemChange.bind(this)}
                paymentMethod={this.state.paymentMethod}
                itemTypes={this.props.isReplacementOrder ? [] : [ProductType.CARD_MACHINE, ProductType.ACCESSORY, ProductType.POINT_OF_SALE]}
            />
            <div className="row">
              <div className="col-lg-3"/>
              <div className="col-lg-5">
                <button className="btn btn-primary add-button" disabled={this.state.creatingOrder}
                        onClick={this.createOrder.bind(this)}>Add
                </button>
                <a className="btn btn-muted cancel-button" href={document.referrer}>Cancel</a>
              </div>
            </div>
          </div>
          {this.props.confirmAddress &&
              <AddressConfirmationPopup
                  showConfirmation={this.state.showAddressConfirmation}
                  onConfirm={() => {
                    this.setState({addressConfirmed: true, showAddressConfirmation: false}, ()=> this.createOrder())
                  }}
                  onDeny={() => this.setState({showAddressConfirmation: false})}
              />}
        </div>
    )
  }
}

class AddressConfirmationPopup extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmation: this.props.showConfirmation
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showConfirmation !== this.props.showConfirmation) {
      this.setState({showConfirmation: this.props.showConfirmation});
    }
  }

  render() {
    return < waffle.popups.ConfirmPopup
        icon="icon-alert"
        icon_colour="red"
        showing={this.state.showConfirmation}
        title="Confirm Address"
        subtitle="Have you verified that the Customer Details for the order are correct?"
        confirmButtonLabel="Yes"
        cancelButtonLabel="No"
        onConfirm={this.props.onConfirm}
        onCancel={this.props.onDeny}
        onEsc={this.props.onDeny}
    />
  }
}

class OrderApi {
  fetchBusinessInfo(businessUUID) {
    return fetch(`/api/businesses/${businessUUID}`)
        .then((response) => response.json())
  }

  createOrder({
              businessUUID,
              customerDetails,
              commonDetails,
              zaAddressDetails,
              deliveryDetails,
              paymentMethod,
              items,
              country = CountryCode.ZA,
              replacedItems = [],
            }) {

    let orderDetails = {
      shipping_first_name: customerDetails.firstName,
      shipping_last_name: customerDetails.lastName,
      shipping_email: customerDetails.email,
      shipping_mobile_number: customerDetails.mobileNumber,
      shipping_address_line1: commonDetails.firstLine,
      shipping_address_line2: commonDetails.secondLine ? commonDetails.secondLine : "",
      shipping_suburb: zaAddressDetails.suburb ? zaAddressDetails.suburb : "",
      shipping_city: zaAddressDetails.city ? zaAddressDetails.city : "",
      shipping_province: zaAddressDetails.province ? zaAddressDetails.province : "",
      shipping_postal_code: zaAddressDetails.postalCode ? zaAddressDetails.postalCode : "",
      shipping_country: customerDetails.country ? customerDetails.country.value : country,
      shipping_method: deliveryDetails.deliveryMethod,
      dispatch_location: deliveryDetails.dispatchLocation,
      payment_method: paymentMethod,
      business_uuid: businessUUID,
      items: items ? items : [],
    }

    const metadata = {replaced_items: replacedItems}

    // For now, only send the 'delivery_type' in metadata if its not normal
    if (deliveryDetails.deliveryType && deliveryDetails.deliveryType !== "standard") {
      metadata["delivery_type"] = deliveryDetails.deliveryType
    }

    if (replacedItems.length > 0) {
      orderDetails = Object.assign({}, orderDetails, { metadata });
    }

    $.ajax({
      url: `/api/orders/`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(orderDetails)
    }).done((response) => {
      if (response.status === 201) {
        window.location.href = `/logistics/orders/${response.data.id}`;
      } else {
        radio('showAlert').broadcast('danger', `Failed to create order (${response.status}): ${response.message}`);
      }
    }).fail((_, textStatus) => {
      radio('showAlert').broadcast('danger', textStatus);
    });
  }
}

module.exports = {
  OrderPaymentsFilterBlock: OrderPaymentsFilterBlock,
  OrdersFilterBlock: OrdersFilterBlock,
  PaymentMethod: PaymentMethod,
  PaymentState: PaymentState,
  OrderType: OrderType,
  FulfilmentState: FulfilmentState,
  DispatchLocation: DispatchLocation,
  OrderIssuesBanner: OrderIssuesBanner,
  OrderSimCardLink: OrderSimCardLink,
  FulfilmentsFilterBlock: FulfilmentsFilterBlock,
  CreateOrderForm: CreateOrderForm,
};
